import type { PlanEntitlementsRow } from '../../shell/feature-flags/domain/planEntitlements';
import type { FiscalMode } from '../../sales/domain-api';

/**
 * Estrategia del comprobante por defecto en POS (`organizations.default_pos_fiscal_mode`).
 * 'auto_by_payment' = según el medio de cobro: transferencia/QR → fiscal; cash/fiado → no fiscal.
 */
export type PosFiscalDefaultStrategy = 'fiscal' | 'non_fiscal' | 'auto_by_payment';

/** Estrategia por defecto al abrir cobro en POS (respeta plan sin facturación fiscal). */
export function getDefaultPosFiscalMode(
  entitlements: PlanEntitlementsRow | null | undefined,
  allowFiscal: boolean
): PosFiscalDefaultStrategy {
  if (!allowFiscal) return 'non_fiscal';
  const mode = entitlements?.default_pos_fiscal_mode;
  return mode === 'fiscal' || mode === 'auto_by_payment' ? mode : 'non_fiscal';
}

/** Medios de cobro que disparan comprobante fiscal en la estrategia 'auto_by_payment'. */
export const AUTO_FISCAL_PAYMENT_METHOD_IDS: ReadonlySet<string> = new Set([
  'transfer',
  'mercadopago_qr',
  'card',
  'cheque',
]);

/** Resuelve el modo fiscal de la venta según la estrategia y los medios de cobro elegidos. */
export function resolvePosSaleFiscalMode(
  strategy: PosFiscalDefaultStrategy,
  paymentMethodIds: readonly string[]
): FiscalMode {
  if (strategy === 'fiscal') return 'fiscal';
  if (strategy !== 'auto_by_payment') return 'non_fiscal';
  return paymentMethodIds.some((id) => AUTO_FISCAL_PAYMENT_METHOD_IDS.has(id))
    ? 'fiscal'
    : 'non_fiscal';
}
